import { hyperdbTriggers } from 'hyperdb-utils';
import * as config from '../../../../config';

export default hyperdbTriggers({ config,
  namespace: 'AREA',
  entryPoint: '/areas',
  collectionName: 'areas',
  querySearchListing: [
    ['name', ['zone', ['name'] ]],
    { order: { id: 'asc' } }
  ],
  successMessageCreate: 'Area created',
  successMessageUpdate: 'Area updated',
  successMessageDelete: 'Area deleted',
});



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/area/triggers.js